export default __webpack_public_path__ + "static/media/light-solidity-svgrepo-com.35cbcb47.svg";